var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.5 16.5",
    style: {
      enableBackground: "new 0 0 16.5 16.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,3.3l2.1-2.1c1.6-1.6,4.1-1.6,5.7,0s1.6,4.1,0,5.7l-4.2,4.2c-1.6,1.6-4.1,1.6-5.7,0C5,10.7,5,10,5.4,9.7 c0.4-0.4,1-0.4,1.4,0c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0l-1,1C9.3,3.3,8.4,3.2,7.5,3.3z  M8.9,13.2l-2.1,2.1c-1.6,1.6-4.1,1.6-5.7,0s-1.6-4.1,0-5.7l4.2-4.2c1.6-1.6,4.1-1.6,5.7,0c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0 C8.9,6,7.6,6,6.8,6.8l-4.2,4.2c-0.8,0.8-0.8,2,0,2.8c0.8,0.8,2,0.8,2.8,0l1-1C7.2,13.2,8.1,13.3,8.9,13.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2d86abc7.svg";
export { ForwardRef as ReactComponent };